<nav class="left-nav">
  @for (item of perms.menuItems; track item.url) {
    <div class="nav-item-wrapper">
      <a [routerLink]="item.url" routerLinkActive="active" class="nav-item">
        <i class="pi" [ngClass]="item.icon"></i>
        <span class="nav-text">{{ item.text }}</span>
      </a>
      @if (getSubMenu(item).length > 0) {
        <div class="sub-menu">
          @for (sub of getSubMenu(item); track sub.url) {
            <a [routerLink]="sub.url" class="sub-item">{{ sub.text }}</a>
          }
        </div>
      }
    </div>
  }
</nav>
